module.exports = __webpack_public_path__ + "img/download.fc857e53.png";